import { Button, Flex, Row, Space, Spin, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { WarningOutlined } from "@ant-design/icons";

import { useHistory } from "react-router-dom";
import Prefixs from "common/Prefixs";
import ModalExtendNotify from "pages/renewcert/components/ModalExtendNotify";
import { blue } from "@ant-design/colors";
import { LoadingOutlined } from "@ant-design/icons";
import { showNotification } from "common";
import ServiceApi from "apis/ServiceApi";
import { formatDateTimeDMY } from "helpers/formatDate";
import WarningTextStepStart from "../warning-text/WarningTextStepStart";

export default function RenewCertStart({ isStart }) {
  const { Text } = Typography;
  const history = useHistory();
  const [dataInfoCert, setDataInfoCert] = useState({});

  const [loading, setLoading] = useState(false);

  const [isModalExtend, setModalIsExtend] = useState(false);
  useEffect(() => {
    fetchDataDetail();
  }, []);

  const fetchDataDetail = async () => {
    setLoading(true);
    try {
      const res = await ServiceApi.getCertInfoCapBu();
      if (res && res.status === 200 && res.data.data) {
        const dataDetail = res.data.data.data;
        setDataInfoCert(dataDetail);
      } else {
        return null;
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const clickStart = async () => {
    if (dataInfoCert.isExtend) {
      setModalIsExtend(true);
    } else {
      history.push(`${Prefixs.RENEWCERT_INFO}`);
    }
  };

  return (
    <>
      <Spin
        spinning={loading}
        tip="Vui lòng đợi..."
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <div>
          <Typography.Title level={4} className="text-center">
            <>CHƯƠNG TRÌNH CẤP BÙ CHỨNG THƯ SỐ FASTCA USB TOKEN</>
          </Typography.Title>
          <div>
            Quý khách chọn
            <Typography.Text strong>“Bắt đầu”</Typography.Text>
            để thực hiện chương trình cấp bổ sung thời hạn
            <Typography.Text style={{ color: blue.primary }} strong>
              {" "}
              MIỄN PHÍ{" "}
            </Typography.Text>
            cho khách hàng đang sử dụng dịch vụ chữ ký số do FastCA cung cấp và
            có thời hạn chứng thư số hiển thị trên Token là ngày{" "}
            <Text type="danger" strong>
              {formatDateTimeDMY(dataInfoCert?.currentDateEnd)}.
            </Text>
          </div>
          <br />
          <div>
            Trong quá trình cấp bù, Quý khách vui lòng:
            <ol className="instruction-list">
              <li>Giữ máy tính luôn hoạt động</li>
              <li>Chỉ kết nối với một USB Token</li>
              <li>Đảm bảo kết nối mạng ổn định</li>
              <li>
                Không rút token khỏi máy tính trong suốt quá trình thực hiện cấp
                bù cho đến khi token hiển thị thông báo
                <Typography.Text strong>
                  {" "}
                  "Cập nhật chứng thư số thành công!"
                </Typography.Text>
              </li>
            </ol>
          </div>

          <div className="">
            <WarningTextStepStart />
          </div>
        </div>
        {isStart && (
          <Row justify={"center"} className="w-full">
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => clickStart()}
            >
              Bắt đầu
            </Button>
          </Row>
        )}

        <ModalExtendNotify
          isOpen={isModalExtend}
          setIsOpen={setModalIsExtend}
          dataInfoCert={dataInfoCert}
        />
      </Spin>
    </>
  );
}
